export const SETTINGS_LIST_VIEW = "/settings"
export const EDIT_FARM_PROFILE_VIEW = SETTINGS_LIST_VIEW + "/edit-farm-profile"
export const COMPANY_INFO_VIEW = SETTINGS_LIST_VIEW + "/view-company-info"
export const EDIT_MY_PROFILE_VIEW = SETTINGS_LIST_VIEW + "/edit-my-profile"
export const NOTIFICATION_PREFERENCES_VIEW =
  SETTINGS_LIST_VIEW + "/notification-preferences"
export const TUTORIAL_VIEW = SETTINGS_LIST_VIEW + "/tutorial"
export const FAQ_VIEW = SETTINGS_LIST_VIEW + "/faq"
export const CONFIDENTIALITY_VIEW = SETTINGS_LIST_VIEW + "/confidentiality"
export const TERMS_VIEW = SETTINGS_LIST_VIEW + "/terms"
export const CONTACT_VIEW = SETTINGS_LIST_VIEW + "/contact"
